<template>
  <component :is="componentLocal" />
</template>

<script>
// import Vue from 'vue'

export default {
  name: 'ProductDistributorComponent',
  props: {
    entity: {
      type: String,
      default: ''
    },
    component: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      entityLocal: '',
      itemLocal: ''
    }
  },
  computed: {
    componentLocal() {
      return () => import(`@/components/${this.entityLocal}/${this.componentProductPath}/${this.itemLocal}`)
    }
  },
  created () {
    this.entityLocal = this.entity || this.$route.meta.entity
    this.itemLocal = this.component || this.$route.meta.action
    console.log('MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM', this.entityLocal, this.itemLocal)
  }
  // watch: {
  //   componentProductPath(val) {
  //     if (val) {
  //       Vue.component('product-distributor', () => import(`@/components/${this.$route.meta.entity}/${this.componentProductPath}/${this.$route.meta.action}`))
  //     }
  //   }
  // }
}
</script>
